import React, { useContext } from 'react';

import Button from '../../atoms/Button/Button';
import Google from '../../atoms/GoogleIcon/GoogleIcon';
import { getSocialSignIn } from '../../../utils/validationUtils';
import { AirDropContext } from '../../../utils/AirDropProvider';
import './GoogleSignIn.scss';
import { event } from '../../../services/googleAnalytics4';
import useTranslation from '../../hooks/useTranslation';

interface GoogleSigninProp {
  from : string;
}

function GoogleSignIn({ from }: GoogleSigninProp) {
  const config = useContext(AirDropContext);
  const googleSignIn = getSocialSignIn(config, 'googleV2');
  const { translateText } = useTranslation();

  const goToSocialPage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (googleSignIn) {
      event('google_social_signin', 'Google Social Sign In', 'Submit', 'Google Social Sign In submit');
      const socialUrl = from === 'signin' ? googleSignIn.url : googleSignIn.urlCreateAccount;
      window.location.href = socialUrl;
    }
  };

  const buttonText = from === 'signin' ? translateText('Sign in with') : translateText('Continue with');

  return (
    <Button
      id="googleSignInBttn"
      type="button"
      className="ies-btn tertiary cta-button"
      onClick={goToSocialPage}
    >
      <div className="google-logo">
        <Google />
      </div>
      {buttonText}
      <span> Google</span>
    </Button>
  );
}

export default GoogleSignIn;
